<template>
    <v-card
        class="mx-auto"
        style='padding-top:20px;'
    >
        <v-card-text>
        <!-- <div>{{$t('WidgetsArchive.total')}}: {{GETTERS_ARCHIVE_PROPOSAL.length}}</div> -->
        <p class="display-1 text--primary">
             {{$t('WidgetsArchive.attach_old_system')}}
        </p>
        <p>{{$t('WidgetsArchive.possible')}}: 
            <v-chip
                class="ma-2"
                :color="$mainColor"
                style="color:white"
                label
                >
                <v-icon left>
                    mdi-account-circle-outline
                </v-icon>
                {{selectedAuthor !== null ? GETTERS_ARCHIVE_PROPOSAL[selectedAuthor].profile_fio : $t('WidgetsArchive.no_author_selected')}}
                </v-chip>
        </p>
        
        <div class="text--primary">
            <v-simple-table height="200px">
                <template v-slot:default>
                <thead>
                    <tr>
                    <th class="text-left">
                        {{$t('WidgetsArchive.name')}}
                    </th>
                    <th class="text-left">
                        {{$t('WidgetsArchive.users')}}
                    </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                    v-for="item in selectedAuthorProposal"
                    :key="item.name"
                    >
                    <td>{{ item.name }}</td>
                    <td> 
                        <v-chip x-small style='margin-right:3px;' v-for="meta_user in item.meta.users">
                        <v-icon left x-small>
                            mdi-account-circle-outline
                        </v-icon>
                        {{ meta_user }}
                        </v-chip>
                    </td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
        </div>
        </v-card-text>
        <v-card-actions>
        <v-btn
            text
            color="red"
            @click="noProposalGap">{{$t('WidgetsArchive.no_proposals')}}</v-btn>
        <v-btn
            text
            :disabled="selectedAuthor === null"
            color="teal accent-4"
            @click="addProposalGap">{{$t('WidgetsArchive.attach_author')}}</v-btn>
        </v-card-actions>

    </v-card>
    <!-- <v-card
     class="d-flex justify-space-between align-start widget-archive-proposal__dialog">
     
        <v-list
            class="list-authors-archive">
            <v-card-title>{{$t('WidgetsArchive.attach_old_system')}}</v-card-title>
            <v-subheader>{{selectedAuthor !== null ? GETTERS_ARCHIVE_PROPOSAL[selectedAuthor].profile_fio : $t('WidgetsArchive.no_author_selected')}}</v-subheader>
            <v-list-item-group
             class="list-authors-archive__group-item"
             v-model="selectedAuthor">
                <v-list-item
                class="list-authors-archive__author d-flex justify-start align-center"
                v-for="(item, i) in GETTERS_ARCHIVE_PROPOSAL"
                :key="i">
                    <v-list-item-icon>
                        <v-icon>mdi-account</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title v-text="item.profile_fio"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
            <div class="list-authors-archive__button">
                <v-btn
                :color="$mainColor"
                style="color:white"
                @click="noProposalGap">{{$t('WidgetsArchive.no_proposals')}}</v-btn>
                <v-btn
                :disabled="selectedAuthor === null"
                :color="$mainColor"
                style="color:white"
                @click="addProposalGap">{{$t('WidgetsArchive.attach_author')}}</v-btn>
            </div> 
        </v-list>
        <v-list
            class="d-flex flex-column align-start proposals-archive">
            <v-subheader>{{$t('WidgetsArchive.list_proposals')}}</v-subheader>
            <v-list-item-group>
                <v-list-item
                class="proposals-archive__proposal"
                v-for="(item, i) in selectedAuthorProposal"
                :key="i">
                    <v-list-item-icon>
                        <v-icon>mdi-card-bulleted</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title v-text="item.name"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </v-card> -->
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    name: 'WidgetArchiveProposalLayouts',
    data() {
        return {
            successText: this.$t('WidgetsArchive.confirm_author_name'),
            closeText: this.$t('WidgetsArchive.confirm_not_present'),
            selectedAuthor: null,
            selectedAuthorProposal: [],
            idAuthor: null,
            idProposal: [],
            idProposalNo: [],
            ft: []
        }
    },
    computed: {
        ...mapGetters(['GETTERS_ARCHIVE_PROPOSAL'])
    },
    mounted() {
        let timer = setInterval(() => {
            if (this.GETTERS_ARCHIVE_PROPOSAL) {
                this.selectedAuthor = 0
                clearInterval(timer)
            }
        }, 200)
    },
    methods: {
        close() {
            this.$emit(
                'close',
                {
                    text: this.closeText,
                    proposal: {id: localStorage.isLoggedIn, proposals: []}
                }
            )
        },
        noProposalGap() {
            this.selectedAuthor !== this.GETTERS_ARCHIVE_PROPOSAL.length ? this.selectedAuthor++ : null

            if(this.selectedAuthor === this.GETTERS_ARCHIVE_PROPOSAL.length) this.addProposal()
        },
        addProposalGap() {
            this.selectedAuthorProposal.forEach(item => {
                this.idProposal.push(item.id)
            })

            this.selectedAuthor !== this.GETTERS_ARCHIVE_PROPOSAL.length ? this.selectedAuthor++ : null
            
            if(this.selectedAuthor === this.GETTERS_ARCHIVE_PROPOSAL.length) this.addProposal()
        },
        addProposal() {
            /*const idProposal = [];

            this.selectedAuthorProposal.forEach(item => {
                idProposal.push(item.id)
            })*/
            
            this.$emit(
                'add',
                {
                    text: this.successText,
                    proposal: {id: localStorage.isLoggedIn, proposals: this.idProposal}
                }
            )
        }
    },
    watch: {
        selectedAuthor(val) {
            
            this.selectedAuthorProposal = this.GETTERS_ARCHIVE_PROPOSAL[val].suggestions
            this.$emit('name-author', this.GETTERS_ARCHIVE_PROPOSAL[val].profile_fio)
        },
        
    }
}
</script>
<style scoped>
.list-authors-archive {
    width: 20%;
    background: #E2E4E6;
    color: #022B61;
    height: 100%;
    min-height: 800px;
    max-height: 800px;
    position: relative;
}
.list-authors-archive__author {
    border-radius: 3px;
    background: white;
    margin-bottom: 10px;
    margin-left: 15px;
}

.list-authors-archive__group-item {
    padding-right: 15px;
    max-height: 30vw;
    min-height: 1vw;
    overflow-y: auto;
}
.proposals-archive {
    width: 78%;
    height: 100%;
    min-height: 100px;
    max-height: 800px;
}
.proposals-archive .v-item-group {
    overflow-y: auto;
    width: 100%;
    padding-right: 15px;
}
.proposals-archive__proposal {
    border-radius: 3px;
    margin-bottom: 10px;
    background-color: white !important;
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}
.widget-archive-proposal__dialog {
    max-height: 800px;
    min-height: 800px;
    height: 100%;
}
.list-authors-archive__button {
    position: absolute;
    bottom: 0;
    padding: 0 15px;
    width: 100%;
}
.list-authors-archive__button button {
    width: 100%;
    text-align: center;
    margin-bottom: 5px;
    font-size: .8vw;
}
@media screen and (max-width:1300px) {
    .list-authors-archive {
        width: 40%;
    }
    .proposals-archive {
        padding-right: 15px;
        width: 58%;
    }
    .list-authors-archive__button button {
        font-size: 1vw;
    }
}/*
@media screen and (max-width:768px) {
   .widget-archive-proposal__dialog {
       flex-direction: column;
   }
   .list-authors-archive__button {
       position: static;
   }
   .list-authors-archive {
       min-height: 100px;
       max-height: 150px;
       height: 100%;
       width: 100%;
       display: flex;
       justify-content: space-between;
       align-items: center;
   }
}*/
</style>